/* PRIETT — shared UX helpers: a slim top progress bar + button loading state.
   Gives consistent "something is happening" feedback for cart/add/navigation
   instead of dimming content. Exposed as window.PriettUX. */
(function () {
  if (window.PriettUX) return;

  var bar, fill, timer, val = 0, pending = 0, toastWrap;

  function ensureBar() {
    if (bar) return;
    bar = document.createElement('div');
    bar.className = 'pe-progress';
    fill = document.createElement('div');
    fill.className = 'pe-progress-fill';
    bar.appendChild(fill);
    (document.body || document.documentElement).appendChild(bar);
  }

  function tick() {
    // ease asymptotically toward 90% so it always feels alive but never completes early
    val += (90 - val) * 0.14;
    if (fill) fill.style.width = val.toFixed(1) + '%';
  }

  function start() {
    ensureBar();
    bar.classList.add('on');
    if (val < 8) { val = 8; if (fill) fill.style.width = '8%'; }
    clearInterval(timer);
    timer = setInterval(tick, 170);
  }

  function finish() {
    clearInterval(timer);
    if (!bar) return;
    val = 100;
    fill.style.width = '100%';
    setTimeout(function () {
      bar.classList.remove('on');
      setTimeout(function () { val = 0; if (fill) fill.style.width = '0%'; }, 240);
    }, 220);
  }

  window.PriettUX = {
    // ref-counted so overlapping requests keep the bar alive until all settle
    start: function () { pending++; start(); },
    done: function () { pending = Math.max(0, pending - 1); if (pending === 0) finish(); },
    // toggle a spinner inside any button (text hidden via .is-loading CSS)
    btnLoading: function (btn, on) {
      if (!btn) return;
      if (on) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      else { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    },
    // brief success check state on a button
    btnDone: function (btn, ms) {
      if (!btn) return;
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); }, ms || 1300);
    },
    // lightweight, self-dismissing toast notification. opts: {icon:'heart', action:{label, cb}, duration}
    toast: function (msg, opts) {
      opts = opts || {};
      if (!toastWrap) {
        toastWrap = document.createElement('div');
        toastWrap.className = 'pe-toast-wrap';
        toastWrap.setAttribute('role', 'status');
        toastWrap.setAttribute('aria-live', 'polite');
        (document.body || document.documentElement).appendChild(toastWrap);
      }
      // single-toast behaviour: clear any showing toast so rapid actions read cleanly
      toastWrap.querySelectorAll('.pe-toast').forEach(function (el) { el.remove(); });

      var t = document.createElement('div');
      t.className = 'pe-toast';
      var ic = '';
      if (opts.icon === 'heart') ic = '<svg class="pe-toast__ic" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20.3 4.9 13.1A4.5 4.5 0 0 1 11.3 6.7l.7.7.7-.7a4.5 4.5 0 0 1 6.4 6.4L12 20.3Z"/></svg>';
      else if (opts.icon === 'check') ic = '<svg class="pe-toast__ic" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m9.6 16.2-3.8-3.8 1.4-1.4 2.4 2.4 6.8-6.8 1.4 1.4z"/></svg>';
      t.innerHTML = ic + '<span class="pe-toast__msg"></span>';
      t.querySelector('.pe-toast__msg').textContent = msg;

      if (opts.action && opts.action.label) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pe-toast__action';
        btn.textContent = opts.action.label;
        btn.addEventListener('click', function () { try { if (opts.action.cb) opts.action.cb(); } finally { dismiss(); } });
        t.appendChild(btn);
      }
      toastWrap.appendChild(t);

      var killed = false, to;
      function dismiss() {
        if (killed) return; killed = true;
        clearTimeout(to);
        t.classList.remove('on');
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 340);
      }
      requestAnimationFrame(function () { t.classList.add('on'); });
      to = setTimeout(dismiss, opts.duration || 3200);
      return { dismiss: dismiss };
    }
  };
})();
